import { appResource, BeanSimple, cast } from 'zova';
import { __ThisModule__ } from './.metadata/this.js';
export class Monkey extends BeanSimple {
  constructor(moduleSelf) {
    super();
    this._moduleSelf = void 0;
    this._defaultModuleApi = void 0;
    this._moduleSelf = moduleSelf;
  }
  async moduleLoading(_module) {}
  async moduleLoaded(module) {
    // load apis
    const promises = [];
    promises.push(this._loadApis(module, 'api'));
    promises.push(this._loadApis(module, 'apiSchema'));
    await Promise.all(promises);
    // self
    if (this._moduleSelf === module) {
      const scopeSelf = await this.bean.getScope(__ThisModule__);
      this._defaultModuleApi = scopeSelf.config.defaultModuleApi;
      await this.app.meta.module.use(this._defaultModuleApi);
    }
  }
  async beanInit(bean, beanInstance) {
    const self = this;
    for (const sceneName of ['api', 'apiSchema']) {
      bean.defineProperty(beanInstance, `$${sceneName}`, {
        enumerable: false,
        configurable: true,
        get() {
          return cast(self.app.bean.scope(self._defaultModuleApi))[sceneName];
        }
      });
    }
  }
  async _loadApis(module, sceneName) {
    const onions = appResource.scenes[sceneName]?.[module.info.relativeName];
    if (!onions) return;
    const scope = this.bean.scope(module.info.relativeName);
    const beanFullNames = Object.keys(onions);
    const promises = [];
    for (const beanFullName of beanFullNames) {
      promises.push(this.bean._getBean(beanFullName, true));
    }
    const values = await Promise.all(promises);
    for (let index = 0; index < beanFullNames.length; index++) {
      const beanFullName = beanFullNames[index];
      const beanOptions = onions[beanFullName];
      scope[sceneName][beanOptions.name] = values[index];
    }
  }
}